export default "__VITE_ASSET__Drr21pbE__"